import React from 'react';
import Slider from 'react-slick';
import Link from '../../Link';

import ArrowLeftWhite from '../../animateArrow/ArrowLeftWhite';
import ArrowRightWhite from '../../animateArrow/ArrowRightWhite';
import ProductBgArrow from '../../animateArrow/ProductBgArrow';
import Card from '../../card/Card';

import PropTypes from 'prop-types';

const SectionCarousel1 = (props) => {
  const [setting] = React.useState({
    dots: false,
    infinite: false,
    slidesToShow: 3,
    draggable: true,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          slidesToShow: 2,
          variableWidth: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrows: true,
          slidesToShow: 1,
          variableWidth: true,
        },
      },
    ],
  });

  const renderBg = () => {
    switch (props.bgStyle) {
      case 'arrow':
        return (
          <div className='section-bg'>
            <ProductBgArrow />
          </div>
        );
      default:
        return (
          <div className='section-bg'>
            <ArrowLeftWhite />
            <ArrowRightWhite />
          </div>
        );
    }
  };

  return (
    <section className='fui-horzonal-cards' id={props.id}>
      {renderBg()}
      <div className='fui-container'>
        <h2 className='section-title align-left'>{props.title}</h2>
        <Slider {...setting} className='horizontal-cards'>
          {props.cards.map((card, idx) => (
            <Card key={idx} {...card} style={{ width: 270 }} />
          ))}
        </Slider>
        {props.more ? (
          <div className='align-center'>
            <Link to={props.more.link} className='fui-more'>
              {props.more.text}
              <br />
              <i className='icon-chevron-down'></i>
            </Link>
          </div>
        ) : (
            ''
          )}
      </div>
    </section>
  );
};

SectionCarousel1.propTypes = {
  title: PropTypes.string,
  cards: PropTypes.array,
  bgStyle: PropTypes.string,
  more: PropTypes.shape({
    text: PropTypes.string,
    link: PropTypes.string,
  }),
};

export default SectionCarousel1;
